export default {
  csl1: 'fill: #fff;',
  csl2: 'fill:rgba(255,255,255,0.73);',
};
